import { AlertCircleIcon } from 'lucide-react'
import type { ReactNode } from 'react'

import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'

export const AgencyDetailError = (): ReactNode => (
  <div className="agency-detail-wrapper flex h-full flex-col p-6">
    <Alert variant="destructive">
      <AlertCircleIcon className="size-4" />
      <AlertTitle>Error loading agency</AlertTitle>
      <AlertDescription>
        There was a problem loading the agency details. Please try again later.
      </AlertDescription>
    </Alert>
  </div>
)
